module.exports = __webpack_public_path__ + "assets/img/login.10f7b12e.png";